import React from "react";
import TeamReportItem from "./TeamReportItem";
import ReportItem from "./ReportItem";

export default function ReportItemWrapper(props) {
  const { report } = props;

  return report.isTeamReport ? (
    <TeamReportItem {...props} />
  ) : (
    <ReportItem {...props} />
  );
}
